import React from 'react';
import useField from '@/modules/WebForm/hooks/useField';
import { createAnswer } from '@/modules/WebForm/utils';
import { QuestionModel } from '@/modules/core/domain/interfaces/IFormulary';
import WCDatePicker from '@/components_v2/WCDatePicker';
import FormControlComponent from '../FormControlComponent';
import { useTranslation } from 'react-i18next';

const DateTimeContent: React.FC<QuestionModel> = () => {
  const { error, onChange, fieldState } = useField();
  const { t } = useTranslation();

  const value = React.useMemo(() => {
    if (fieldState && !Array.isArray(fieldState)) {
      if (typeof fieldState.content === 'number') {
        return new Date(fieldState.content * 1000);
      }
      if (fieldState.content instanceof Date) {
        return fieldState.content;
      }
      return new Date(parseInt(fieldState.content, 10) * 1000);
    }
    return undefined;
  }, [fieldState]);

  const handleChange = React.useCallback(
    (newValue: Date | null) => {
      onChange(
        createAnswer(
          newValue ? Math.trunc(newValue.getTime() / 1000) : undefined,
        ),
      );
    },
    [onChange],
  );

  return (
    <FormControlComponent isInvalid={error}>
      <WCDatePicker
        withPortal
        dateFormat="dd/MM/yyyy HH:mm"
        timeFormat="HH:mm"
        timeInputLabel={`${t('form_labels.hour')}:`}
        shouldCloseOnSelect={false}
        showTimeInput
        onChange={handleChange}
        selected={value}
      />
    </FormControlComponent>
  );
};

export default DateTimeContent;
